meedy.controller('meedy.settingsController', ['$rootScope', '$scope', '$state', '$mdToast', '$mdDialog', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel',
    function ($rootScope, $scope, $state, $mdToast, $mdDialog, objectHelper, applicationModel, userModel) {

        var title = 'T.MEEDY.MODULE.SETTINGS.SETTINGS';

        function getSelectedTabIndex () {
            switch ($state.current.name) {
                case Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA:
                    return 0;
                case Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.LIST:
                case Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.CREATE:
                case Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.EDIT:
                    return 1;
                case Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST:
                case Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.CREATE:
                case Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.EDIT:
                    return 2;
                case Constant.STATE.APP.MEEDY.SETTINGS.PRICE_LIST:
                    return 3;
                case Constant.STATE.APP.MEEDY.SETTINGS.USER.LIST:
                case Constant.STATE.APP.MEEDY.SETTINGS.USER.CREATE:
                case Constant.STATE.APP.MEEDY.SETTINGS.USER.EDIT:
                    return 4;
            }
        }

        function setData() {
            $scope.vm = {
                selectedTabIndex: 0
            };

            $scope.addButtonVisible = false;
            $scope.backButtonVisible = false;
            $scope.title = title;

            $scope.currentUser = userModel.currentUser;
        }

        function setListeners() {
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isMedicalReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST;
            $scope.isReceptionist =  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setActions() {
            $scope.showAddButton = function (action) {
                $scope.addButtonVisible = true;
                $scope.create = action;
            };

            $scope.hideAddButton = function () {
                $scope.addButtonVisible = false;
                $scope.create = function () {};
            };

            $scope.showBackButton = function () {
                $scope.backButtonVisible = true;
            };

            $scope.hideBackButton = function () {
                $scope.backButtonVisible = false;
            };

            $scope.setTitle = function (title) {
                $scope.title = title;
            };

            $scope.resetTitle = function () {
                $scope.title = title;
            };
        }

        function configureInterface() {

        }

        function initialize() {
            $scope.vm.selectedTabIndex = getSelectedTabIndex();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
